import { vfColours } from '../MyTheme';

export const CONTACT = {
    EMAIL: 'customer_service@vouchedfor.co.uk',
    PHONE_NUMBER: '0203 111 0580',
    ACCOUNTS_TEAM_NUMBER: '0203 111 0583',
};

export const FA_MONTHLY_CHARGE = '£54 + VAT';
export const ACCOUNTS_MONTHLY_CHARGE = '£36 + VAT';

export const ENQUIRY_REFUND_WINDOW_DAYS = 3;

export const PASSWORD_ERROR = {
    NOTIFICATION:
        'Sorry, it looks like there was an error with your username or password. Please try again, or contact us',
    INPUT_MESSAGE:
        '* Your password must be at least 8 characters, with a combination of lower and upper case letters and numbers',
};

export const VERIFY_SERVICE_ROUTES = {
    PROFILE: 'basic-profile',
    VERIFY: 'verify-services',
    SERVICES: 'services',
    CHOICES: 'services-choices',
    SETTINGS: 'account-settings',
};

export const NO_REWARDS_ID = 4;

export const ALL_REVIEWERS_ALL_TIME = 'all_reviewers_all_time';

export const MAX_FILE_UPLOAD_SIZE_TWO_MB = 2000000;
export const MAX_FILE_UPLOAD_SIZE_FIVE_MB = 5000000;

export const ANALYTICS_LABEL = {
    no_reviews_for_30_days_send_invitations: 'Invite reviews',
    no_first_impression_reviews_for_21_days: 'Invite first impression',
};

export const DISABLED_MENU_ELEVATION_TOOLTIP =
    'To access this feature you need to upgrade to Elevation.';

export const ELEVATION_SIDEBAR_GKAS = [
    'elevation',
    'elevation-client-answers',
    'action-list',
    'elevation-v2',
    'elevation-client-answers-v2'
];

export const PUBLIC_PROFILE_BENEFITS_V2 = [
    {
        primary: 'Boost your presence on search engines',
        icon: 'trending_up',
        key: 'boost_presence',
    },
    {
        primary: 'Gain marketing tools to build trust at every touchpoint',
        icon: 'star',
        key: 'gain_marketing_tools',
    },
    {
        primary: 'Qualify as a Top Rated Adviser in The Times and Telegraph (3 million+ reach)',
        icon: 'trophy',
        key: 'qualify_as_top_rated',
    },
];

export const VERIFIED_UPGRADE_FEATURES= [
    {
        text: '79% of clients more likely to refer their adviser having read their VouchedFor reviews',
        icon: 'check_circle_outline',
        key: 'client_refer_their_adviser',
    },
    {
        text: 'Gain 8+ additional clients per year',
        icon: 'check_circle_outline',
        key: 'gain_additional_clients',
    },
    {
        text: 'Collect and display unlimited client reviews',
        icon: 'check_circle_outline',
        key: 'unlimited_client_reviews',
    },
    {
        text: 'Eligible to feature in The Times and The Telegraph',
        icon: 'check_circle_outline',
        key: 'eligible_in_times_and_telegraph',
    },
    {
        text: 'Referral generator & reputation tools',
        icon: 'check_circle_outline',
        key: 'ref_generator_and_rep_tools',
    },
    {
        text: 'Unlimited social media cards',
        icon: 'check_circle_outline',
        key: 'social_media_cards',
    },
];

export const VERIFIED_PLUS_UPGRADE_FEATURES= [
    {
        text: 'Enhanced search visibility',
        icon: 'check_circle_outline',
        key: 'enhanced_search_visibility',
    },
    {
        text: 'Expertise tags, FAQs & published articles on your profile',
        icon: 'check_circle_outline',
        key: 'expertise_tags_faqs_and_articles',
    },
    {
        text: 'AI-generated profile summary',
        icon: 'check_circle_outline',
        key: 'ai_summary',
    },
    {
        text: 'Pinned best client reviews to top of profile',
        icon: 'check_circle_outline',
        key: 'pinned_reviews',
    },
];

export const PRIVATE_MODE_STATISTICS_TEXT = {
    overall_rating: {
        preText: 'Your rating, from',
        sucText: 'reviews',
    },
    client_advocacy: {
        text: 'of clients say they’re passionate advocates',
    },
    prospect_intentions: {
        text: 'of prospects say they will go on to become clients',
    },
};

export const LOCATION_CHANGE_DISCLAIMER =
    'Please note, when you change towns, your Google listing usually takes between 1-14 days to update. If it takes longer than this, please contact our customer service team';

export const ELEVATION_DASHBOARD_HEADER_TEXT =
    'Your firm is signed up to VouchedFor Elevation to support you in delivering the highest standards of client experience. Below is your report showing your performance across the three key goals and the drivers that contribute to each goal.';

export const FEATURE_ELEVATION_CHECKBOX = 'elevation_checkbox';
export const FEATURE_SHOW_FIRM_PAGE  = 'show-firm-page';

export const FEATURE_ELEVATION_V2_DASHBOARD = 'elevation-v2-dashboard';

export const QUILTER_NETWORK_ID = 3;
